module.exports = __webpack_public_path__ + "static/media/logo-(tertiary-white).8a1c23c8.png";